module.exports = __webpack_public_path__ + "static/media/website-layout.946b23ab.svg";